import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { cancelJobCount, newFtmCount } from "./service";
import FullSidebar from "./components/fullSidebar";
import IconSidebar from "./components/iconSidebar";

const Sidebar = ({isFullSidebar, setIsFullSidebar}) => {
    const [ftmCount, setFtmCount] = useState(0);
    const [jobCount, setCancelJobCount] = useState(0);
    const sidebarRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        // Add error handling for data fetching
        const fetchCounts = async () => {
            try {
                await Promise.all([
                    newFtmCount(setFtmCount),
                    cancelJobCount(setCancelJobCount)
                ]);
            } catch (error) {
                console.error('Error fetching counts:', error);
            }
        };
        
        fetchCounts();
    }, []);

    useEffect(() => {
        // Scroll to active menu item when location changes
        const scrollToActiveItem = () => {
            setTimeout(() => {
                const activeNavLink = sidebarRef.current?.querySelector('.nav-link.active');
                if (activeNavLink && sidebarRef.current) {
                    const sidebarContainer = sidebarRef.current.querySelector('#sidenav-collapse-main');
                    if (sidebarContainer) {
                        const containerRect = sidebarContainer.getBoundingClientRect();
                        const activeRect = activeNavLink.getBoundingClientRect();
                        
                        // Calculate the scroll position to center the active item
                        const scrollTop = activeNavLink.offsetTop - (containerRect.height / 2) + (activeRect.height / 2);
                        
                        sidebarContainer.scrollTo({
                            top: scrollTop,
                            behavior: 'smooth'
                        });
                    }
                }
            }, 100); // Small delay to ensure DOM is updated
        };

        scrollToActiveItem();
    }, [location.pathname]);


    return(
        <>
            {isFullSidebar ? (
                <FullSidebar 
                    ftmCount = {ftmCount}
                    jobCount = {jobCount}
                    isFullSidebar = {isFullSidebar}
                    setIsFullSidebar = {setIsFullSidebar}
                    sidebarRef = {sidebarRef}
                />
            ) : (
                <IconSidebar 
                    ftmCount = {ftmCount}
                    jobCount = {jobCount}
                    isFullSidebar = {isFullSidebar}
                    setIsFullSidebar = {setIsFullSidebar}
                    sidebarRef = {sidebarRef}
                />
            )}
        </>
    );
}

export default Sidebar;